<section class="p-3">
    <div class="mb-3">
        <div class="flex cursor-pointer w-full flex-wrap md:flex-nowrap" on:click={editUserBalances}>
            <Card.Card hover={false} class="shadow p-2 border w-full">
                <div slot="text">
                    <div class="text-xl text-center">
                        { NumberUtils.formatMonetary(userBalance.bankBalance) }
                    </div>
                    <div class="text-center">Pangakonto</div>
                </div>
            </Card.Card>
            <Card.Card hover={false} class="shadow p-2 md:mx-1 border w-full">
                <div slot="text">
                    <div class="text-xl text-center">
                        { NumberUtils.formatMonetary(userBalance.cashBalance) }
                    </div>
                    <div class="text-center">Sularaha</div>
                </div>
            </Card.Card>
            <Card.Card hover={false} class="shadow p-2 border w-full">
                <div slot="text">
                    <div class="text-xl text-center">
                        { NumberUtils.formatMonetary(userTotalBalances) }
                    </div>
                    <div class="text-center">Kokku</div>
                </div>
            </Card.Card>
        </div>
        <span class="text-xs text-gray-500">Jäägid viimati uuendatud { dayjs(userBalance.modifiedAt).format('DD.MM.YYYY HH:MM') }</span>
    </div>

    <div class="flex justify-between mb-2">
        <Button on:click={manageCashEntryCategories} color="secondary" class="flex align-middle">
            <Icon class="mr-1">list</Icon>
            <span class="self-center">Vaata/muuda kategooriaid</span>
        </Button>
        <Button on:click={createCashEntry} class="flex align-middle">
            <Icon>add</Icon>
            <span class="self-center">Lisa uus rida</span>
        </Button>
    </div>

    <div class="xs:overflow-x-scroll">
        <table class="cash-entry-table">
            <tr class="p-10">
                <th colspan="5">
                    <div class="flex">
                        <div class="mr-3">
                            <span>Sorteeri: </span>
                            <select class="border rounded p-1" bind:value={filters.sort}>
                                <option value={null}>-</option>
                                {#each cashEntrySortOptions as option}
                                    <option value={option.value}>{option.text}</option>
                                {/each}
                            </select>
                        </div>
                        <div>
                            <span>Kategooria: </span>
                            <select class="border rounded p-1" bind:value={filters.category}>
                                <option value={null}>-</option>
                                {#each cashEntryCategoriesOptions as option}
                                    <option value={option.value}>{option.text}</option>
                                {/each}
                            </select>
                        </div>
                    </div>
                </th>
            </tr>
            <tr class="p-10">
                <th colspan="5">
                    Summad kokku: { totalCashEntriesAmount }
                </th>
            </tr>
            <tr class="p-10">
                <th class="w-0.5">Nr</th>
                <th>Kategooria</th>
                <th>Nimetus</th>
                <th>Summa</th>
                <th class="w-1"></th>
            </tr>
            {#each filteredCashEntries as entry, i}
                <tr>
                    <td class="cursor-pointer" on:click={editCashEntry(entry)}>{ i + 1 }</td>
                    <td class="cursor-pointer" on:click={editCashEntry(entry)}>
                        {#if entry.categories.length && entry.categories[0].title}
                            <CashEntryCategoryChip {entry}/>
                        {/if}
                    </td>
                    <td class="cursor-pointer" on:click={editCashEntry(entry)}>{ entry.title }</td>
                    <td class="cursor-pointer"
                        on:click={editCashEntry(entry)}>{ NumberUtils.formatMonetary(entry.amount) }</td>
                    <td>
                        <Button color="error" small class="flex align-middle px-1" remove="px-4 pl-2 pr-2"
                                on:click={deleteEntry(entry)}>
                            <Icon small>delete</Icon>
                        </Button>
                    </td>
                </tr>
            {/each}
            <tr class="p-10">
                <th colspan="5">
                    Summad kokku: { totalCashEntriesAmount }
                </th>
            </tr>
        </table>
    </div>

    {#if showCashEntryDialog}
        <CashEntryDialog bind:showDialog={showCashEntryDialog} bind:entry={editableEntry}
                     on:create:cash-entry={addCashEntry} on:update:cash-entry={updateCashEntry}/>
    {/if}

    {#if showUserBalanceDialog}
        <UserBalanceDialog bind:showDialog={showUserBalanceDialog} {userBalance}
                           on:update:user-balance={updateUserBalance}/>
    {/if}

    {#if showCashEntryCategoryManagementDialog}
        <CashEntryCategoryManagementDialog bind:showDialog={showCashEntryCategoryManagementDialog}/>
    {/if}
</section>

<script lang="ts">
  import {Button, Icon, Card, Select} from 'smelte';
  import CashEntryDialog from '../components/CashEntryDialog.svelte';
  import {onMount} from 'svelte';
  import ApiService from '../api-service';
  import {userInfo, snackbar} from '../stores';
  import UserBalanceDialog from '../components/UserBalanceDialog.svelte';
  import dayjs from 'dayjs';
  import NumberUtils from '../utils/number-utils';
  import {showConfirm} from '../utils/app-utils';
  import CashEntryCategoryManagementDialog from '../components/CashEntryCategoryManagementDialog.svelte';
  import CashEntryCategoryChip from '../components/CashEntryCategoryChip.svelte';

  let showCashEntryDialog: boolean = false;
  let showUserBalanceDialog: boolean = false;
  let showCashEntryCategoryManagementDialog: boolean = false;

  let cashEntries: any[] = [];
  let editableEntry: any = null;
  let userBalance: object = {};
  let cashEntryCategories: any[] = [];

  let filters: any = {
    sort: null,
    category: null
  };

  const cashEntrySortOptions = [
    {
      text: 'Nimetus A-Z',
      value: 'TITLE_A-Z'
    },
    {
      text: 'Nimetus Z-A',
      value: 'TITLE_Z-A'
    },
  ];

  $: cashEntryCategoriesOptions = cashEntryCategories.map(c => {
    return {text: c.title, value: c.id};
  });

  $: filteredCashEntries = filterCashEntries(cashEntries, filters);

  $: totalCashEntriesAmount = calculateTotalCashEntriesAmount(cashEntries);
  $: userTotalBalances = sumUserBalances(userBalance);

  onMount(async () => {
    const response = await ApiService.getCashEntriesForUser($userInfo.id);
    cashEntries = filteredCashEntries = response.data;

    const response2 = await ApiService.getCurrentUserBalances();
    userBalance = response2.data;

    const response3 = await ApiService.getCashEntryCategoriesForUser($userInfo.id);
    cashEntryCategories = response3.data;
  });

  function createCashEntry() {
    editableEntry = null;
    showCashEntryDialog = true;
  }

  function editCashEntry(entry) {
    editableEntry = entry;
    showCashEntryDialog = true;
  }

  function addCashEntry(event) {
    cashEntries = [...cashEntries, event.detail];
  }

  function updateCashEntry(event) {
    const index = cashEntries.findIndex(entry => entry.id === event.detail.id);
    cashEntries[index] = event.detail;
  }

  async function deleteEntry(entry) {
    showConfirm('Rea kustutamine', 'Kas olete kindel, et soovite valitud rida kustutada?')
      .then(async () => {
        await ApiService.deleteCashEntry(entry);
        cashEntries = cashEntries.filter(e => e.id !== entry.id);
        snackbar.show('Rida kustutatud');
      });
  }

  function calculateTotalCashEntriesAmount(cashEntries) {
    return Number(cashEntries.reduce((total, entry) => total + entry.amount, 0)).toFixed(2);
  }

  function sumUserBalances(userBalance) {
    return userBalance.cashBalance + userBalance.bankBalance;
  }

  function editUserBalances() {
    showUserBalanceDialog = true;
  }

  function updateUserBalance(event) {
    userBalance = event.detail;
  }

  function manageCashEntryCategories() {
    showCashEntryCategoryManagementDialog = true;
  }

  function filterCashEntries(cashEntries, filters) {
    let filteredCashEntries = cashEntries;
    if (!filters.sort || filters.sort === 'TITLE_A-Z') {
      filteredCashEntries = filteredCashEntries.sort((a, b) => {
        if (a.title < b.title) {
          return -1;
        } else if (a.title > b.title) {
          return 1;
        } else {
          return 0;
        }
      });
    } else if (filters.sort === 'TITLE_Z-A') {
      filteredCashEntries = filteredCashEntries.sort((a, b) => {
        if (a.title > b.title) {
          return -1;
        } else if (a.title < b.title) {
          return 1;
        } else {
          return 0;
        }
      });
    }

    // Category filter
    if (filters.category) {
      filteredCashEntries = filteredCashEntries.filter(ce => {
        if (ce.categories && ce.categories.length > 0) {
          return ce.categories[0].id === filters.category;
        }
        return false;
      });
    }

    return filteredCashEntries;
  }
</script>

<style>
    .cash-entry-table {
        @apply w-full shadow rounded border-separate;
        border-spacing: 0;
    }

    .cash-entry-table tr th,
    .cash-entry-table tr td {
        @apply border-r border-b text-sm;
    }

    .cash-entry-table tr th:first-child,
    .cash-entry-table tr td:first-child {
        @apply border-l;
    }

    .cash-entry-table tr th {
        @apply border-t font-medium text-left p-3;
    }

    .cash-entry-table tr td {
        @apply p-3;
    }

    .cash-entry-table tr:hover {
        @apply bg-gray-200;
    }

    .cash-entry-table tr:first-child th:first-child {
        @apply rounded-tl;
    }

    .cash-entry-table tr:first-child th:last-child {
        @apply rounded-tr;
    }

    .cash-entry-table tr:last-child td:first-child {
        @apply rounded-bl;
    }

    .cash-entry-table tr:last-child td:last-child {
        @apply rounded-br;
    }
</style>